export {default} from './PromoteListingDetailModel';
export * from './PromoteListingDetailModel';



// WEBPACK FOOTER //
// ./src/models/PromoteListingDetailModel/index.ts